import { useCallback } from "react";
import {
  TransportKeyPayload,
 TransportKeyServiceOperators
} from "../../types/transportkey";
import {
  transportKey,
  userInfoActions
} from "../../store/user/slice";
import { useAppDispatch, useAppSelector } from "../../store/root/hooks";

const useGenerateTransportKey =  (): Readonly<TransportKeyServiceOperators> => {
  const dispatch = useAppDispatch();
  return {
    transportKey:  useAppSelector(transportKey),
    getTransportKey: useCallback(
      (payload: TransportKeyPayload) => {
        console.log("Service:",payload);
        dispatch(userInfoActions.fetchAllisLoading());
        dispatch(userInfoActions.fetchAll(payload));
      },
      [dispatch]
    ),
  
  };
};

 
export { useGenerateTransportKey };
